module.exports = __webpack_public_path__ + "logo_azure.7f70b.png";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/azure/logo_azure.png
// module id = 4054
// module chunks = 0